const initialState = {
	users: "",
};

const otpReducer = (state = initialState, action) => {
	switch (action.type) {
		case "User_OTP":
			return {
				users: action.payload,
			};
		default:
			return state;
	}
};

export default otpReducer;
